import { ComputedStaticTextInput } from '@framework/form';
import React from 'react';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { IComputedStringWidget } from '../IComputedWidget';
import { useStringExpressionValue } from './useStringExpressionValue';

export interface IComputedStringWidgetComponentProps
  extends IWidgetComponentProps<IComputedStringWidget> {}

export function ComputedStringWidgetComponent(
  props: IComputedStringWidgetComponentProps,
) {
  const { widget } = props;

  const options = getWidgetProps(props);

  const value = useStringExpressionValue(options.name, widget.expression);

  return (
    <ConfigFormItem
      hidden={widget.layout?.hide}
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={<RichTextAdvancedRender inline text={options?.helpText} />}
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
    >
      <ComputedStaticTextInput
        name={options.name}
        value={value}
        removeBorder={widget.layout?.removeBorder}
        readonly={options.readonly}
      />
    </ConfigFormItem>
  );
}
